{
  "dropzoneLabel": "Zonă de plasare",
  "selectPlaceholder": "Selectați un element",
  "tableResizer": "Instrument de redimensionare",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
